import { resourceText } from '../services/localization';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { fileUploadService } from 'src/app/shared/services/fileUpload.service';
import { attachment } from './attachment.model';

@Component({
  selector: 'app-attachment',
  templateUrl: './attachment.component.html',
  styleUrls: ['./attachment.component.scss'],
  standalone: false
})
export class AttachmentComponent {
  @Input() transmission: string;
  @Output() changed = new EventEmitter<void>();
  readonly MAX_TEXT_ATTACHMENT_SIZE = 600 * 1024; // 600 KB

  uploadProgress: number;
  uploadSub: Subscription;
  apiHost: string = environment.apiHost;
  isLoading: boolean = false;
  counter: number = -1;
  fileName: string[] = [];
  fileUrl: string[] = [];
  attachments: attachment[] = [];
  fileError: string = '';

  constructor(private fileUploadService: fileUploadService) { }

  async onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file || this.isLoading) return;
    this.fileError = '';
    if (this.transmission === 'TEXT' && !this.isValidTextAttachment(file)) {
      this.fileError = resourceText('TEXT_ATTACHMENT_UNSUPPORTED'); input.value = ''; return;
    }
    if (!this.isValidFileSize(file)) {
      this.fileError = resourceText('TEXT_ATTACHMENT_TOO_LARGE', {size:this.maxTextAttachmentSizeKB}); input.value = ''; return;
    }
    this.isLoading = true;
    try {
      const url = await this.fileUploadService.uploadFile(file, file.name, 'attachments');
      if (!url) throw new Error('Attachment URL missing');
      if (this.transmission === 'TEXT') { this.fileName = []; this.fileUrl = []; }
      this.fileName.push(file.name);
      this.fileUrl.push(url);
      this.counter = this.fileName.length - 1;
      this.syncAttachments();
      this.changed.emit();
    } catch { this.fileError = resourceText('ATTACHMENT_UPLOAD_FAILED'); }
    finally { this.isLoading = false; input.value = ''; }
  }

  removeAttachment(index: number): void {
    if (this.isLoading) return;
    this.fileName.splice(index, 1);
    this.fileUrl.splice(index, 1);
    this.counter = this.fileName.length - 1;
    this.syncAttachments();
    this.changed.emit();
  }

  private syncAttachments(): void {
    this.attachments = this.fileName.map((name, index) => ({fileName:name, fileUrl:this.fileUrl[index]}));
  }

  get acceptedFileTypes(): string {
    if (this.transmission === 'TEXT') {
      return [
        '.png',
        '.jpg',
        '.jpeg',
        '.gif',
        '.bmp',
        '.amr',
        '.midi',
        '.mid',
        '.wav',
        '.ac3',
        '.mp3',
        '.3gp',
        '.mp4',
        '.avi',
        '.mpg',
        '.vcard',
        '.vcf'
      ].join(',');
    }

    // EMAIL
    return '';
  }

  isValidTextAttachment(file: File): boolean {
    const allowedExtensions = [
      'png', 'jpg', 'jpeg', 'gif', 'bmp',
      'amr', 'midi', 'mid', 'wav', 'ac3', 'mp3',
      '3gp', 'mp4', 'avi', 'mpg',
      'vcard', 'vcf'
    ];

    const extension = file.name.split('.').pop()?.toLowerCase();

    return allowedExtensions.includes(extension);
  }

  isValidFileSize(file: File): boolean {
    if (this.transmission !== 'TEXT') {
      return true;
    }

    return file.size <= this.MAX_TEXT_ATTACHMENT_SIZE;
  }

  get maxTextAttachmentSizeKB(): number {
    return Math.round(this.MAX_TEXT_ATTACHMENT_SIZE / 1024);
  }

clearAttachments() {
  this.attachments = [];
  this.fileName = [];
  this.fileUrl = [];
  this.counter = -1;
  this.fileError = '';
}

  getAttachments(): attachment[] { return this.attachments; }
}
